import { render } from "./EmpresaImg.vue?vue&type=template&id=3c1f11f0"
import script from "./EmpresaImg.vue?vue&type=script&lang=js"
export * from "./EmpresaImg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__